
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PaymentMethodSelector } from "./PaymentMethodSelector";

interface CreditSaleFormProps {
  customerName: string;
  setCustomerName: (value: string) => void;
  customerContact: string;
  setCustomerContact: (value: string) => void;
  customerAddress: string;
  setCustomerAddress: (value: string) => void;
  partialPayment: string;
  setPartialPayment: (value: string) => void;
  paymentDueDate: string;
  setPaymentDueDate: (value: string) => void;
  calculateTotal: () => number;
  paymentMethod: string;
  onPaymentMethodChange: (value: string) => void;
}

export const CreditSaleForm = ({
  customerName,
  setCustomerName,
  customerContact,
  setCustomerContact,
  customerAddress,
  setCustomerAddress,
  partialPayment,
  setPartialPayment,
  paymentDueDate,
  setPaymentDueDate,
  calculateTotal,
  paymentMethod,
  onPaymentMethodChange,
}: CreditSaleFormProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="customer-name">Nom du client</Label>
          <Input
            id="customer-name"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            placeholder="Nom complet"
          />
        </div>
        <div>
          <Label htmlFor="customer-contact">Contact</Label>
          <Input
            id="customer-contact"
            value={customerContact}
            onChange={(e) => setCustomerContact(e.target.value)}
            placeholder="Téléphone"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="customer-address">Adresse</Label>
        <Textarea
          id="customer-address"
          value={customerAddress}
          onChange={(e) => setCustomerAddress(e.target.value)}
          placeholder="Adresse complète"
          className="h-20 resize-none"
        />
      </div>

      <div>
        <Label htmlFor="partial-payment">Montant à payer en avance</Label>
        <Input
          id="partial-payment"
          type="number"
          value={partialPayment}
          onChange={(e) => {
            const value = e.target.value;
            if (value === "" || (parseFloat(value) >= 0 && parseFloat(value) <= calculateTotal())) {
              setPartialPayment(value);
            }
          }}
          min="0"
          max={calculateTotal()}
          placeholder="0"
        />
        {partialPayment && (
          <p className="text-sm text-muted-foreground mt-1">
            Reste à payer: {(calculateTotal() - parseFloat(partialPayment || "0")).toLocaleString()} FCFA
          </p>
        )}
      </div>

      <div>
        <Label htmlFor="payment-due-date">Date de paiement prévue</Label>
        <Input
          id="payment-due-date"
          type="date"
          value={paymentDueDate}
          onChange={(e) => setPaymentDueDate(e.target.value)}
          min={new Date().toISOString().split('T')[0]}
        />
      </div>

      {parseFloat(partialPayment || "0") > 0 && (
        <PaymentMethodSelector
          selectedMethod={paymentMethod}
          onMethodChange={onPaymentMethodChange}
        />
      )}
    </div>
  );
};
